module.exports = __webpack_public_path__ + "img/headimg.4f501c98.png";